// extracted by mini-css-extract-plugin
export default {"archiveButton":"verification-services-table-cell__archive-button__hEXTq"};